if (!customElements.get('contact-form')) {
  const VALIDITY_ERROR_TYPES = ['valueMissing', 'typeMismatch', 'patternMismatch'];

  class ContactForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.querySelector('#ContactForm-submit')?.addEventListener('click', () => this.onSubmit());
    }

    clearErrors() {
      for (const formElement of this.form.elements) {
        if (!formElement.ariaDescribedByElements?.length) continue;
        const errorElement = formElement.ariaDescribedByElements?.[0] ?? null;
        if (errorElement) errorElement.hidden = true;
        formElement.closest('.field, [id$="-wrapper"]')?.classList.remove('field--with-error');
        formElement.setAttribute('aria-invalid', 'false');
      }
    }

    showError(formElement, errorMessage) {
      formElement.closest('.field, [id$="-wrapper"]')?.classList.add('field--with-error');
      formElement.setAttribute('aria-invalid', 'true');
      const errorElement = formElement.ariaDescribedByElements?.[0] ?? null;
      if (errorElement) {
        const errorTextElement = errorElement.querySelector('.contact-form__error-text');
        if (errorTextElement) errorTextElement.textContent = errorMessage;
        errorElement.hidden = false;
      }
    }

    getMessage(formElement) {
      const validityState = formElement.validity;
      for (const errorType of VALIDITY_ERROR_TYPES) {
        if (validityState[errorType]) {
          return formElement.dataset[errorType] || formElement.validationMessage;
        }
      }
    }

    onSubmit() {
      this.clearErrors();
      let firstInvalidElement = null;

      for (const formElement of this.form.elements) {
        if (!formElement.ariaDescribedByElements?.length) continue;
        if (formElement.checkValidity()) continue;

        const errorMessage = this.getMessage(formElement);
        if (errorMessage) {
          this.showError(formElement, errorMessage);
          if (!firstInvalidElement) firstInvalidElement = formElement;
        }
      }

      if (firstInvalidElement) {
        firstInvalidElement.focus();
        return;
      }
      this.form.submit();
    }
  }

  customElements.define('contact-form', ContactForm);
}
